export default __webpack_public_path__ + "static/media/15.18f27944.jpg";